<template>
  <div>
    <svg :style="fillColor" :width="width" :height="height">
      <polygon :points="hexagonPoints" />
      <text class="number" x="50%" y="45%" alignment-baseline="middle" text-anchor="middle">
        {{ number }}
      </text>
      <text class="description" x="50%" y="57%" alignment-baseline="middle" text-anchor="middle">
        {{ title }}
      </text>
      <text class="subtext" x="50%" y="65%" alignment-baseline="middle" text-anchor="middle">
        {{ subtext }}
      </text>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'InsightHex',
  props: [
    'number',
    'title',
    'subtext'
  ],
  data () {
    return {
      fillColor: {
        fill: '#efefef'
      },
      width: 210
    }
  },
  methods: {
    calculatePointsForHexagon () {
      var points = [
        [ parseFloat((this.width / 2).toFixed(2)), 0 ],
        [ parseFloat(this.width), parseFloat((this.width / Math.sqrt(3) / 2).toFixed(2)) ],
        [ parseFloat(this.width), parseFloat((this.width / Math.sqrt(3) + (this.width / Math.sqrt(3) / 2)).toFixed(2)) ],
        [ parseFloat((this.width / 2).toFixed(2)), parseFloat((this.width / Math.sqrt(3) * 2).toFixed(2)) ],
        [ 0, parseFloat((this.width / Math.sqrt(3) + (this.width / Math.sqrt(3) / 2)).toFixed(2)) ],
        [ 0, parseFloat((this.width / Math.sqrt(3) / 2).toFixed(2)) ]
      ]
      return points.join(' ')
    }
  },
  computed: {
    hexagonPoints: function () {
      return this.calculatePointsForHexagon()
    },
    height: function () {
      return parseFloat((this.width / Math.sqrt(3) * 2).toFixed(2))
    }
  }
}
</script>

<style scoped>
div {
  text-align: center;
}
.number {
  fill: hsl(0, 0%, 4%);
  font-family: "NeutrifPro-Light";
  font-size: 2rem;
}
.description {
  fill: hsl(0, 0%, 4%);
  font-family: "NeutrifPro-Bold";
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 4px;
}

.subtext {
  fill: hsl(0, 0%, 50%);
  font-family: "NeutrifPro-Bold";
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 4px;
}
</style>
